module.exports = __webpack_public_path__ + "img/nav_pic01@3x.a6972884.jpg";